import {BaseCard} from "@/components/BaseCard";
import type {ReactNode} from "react";

interface StatsCardProps {
  label: string;
  value: string;
  change?: string;
  changePositive?: boolean;
  icon: ReactNode;
  iconColor?: string;
}

export const StatsCard = ({
  label,
  value,
  change,
  changePositive = true,
  icon,
  iconColor = "var(--color-primary)",
}: StatsCardProps) => (
  <BaseCard padding="md">
    <div className="flex items-start justify-between">
      <div>
        <p
          className="text-xs font-medium uppercase tracking-wide mb-2"
          style={{color: "var(--color-text-secondary)"}}
        >
          {label}
        </p>
        <p
          className="text-2xl font-bold"
          style={{color: "var(--color-text)"}}
        >
          {value}
        </p>
        {change && (
          <p
            className="text-xs mt-1.5 font-medium"
            style={{
              color: changePositive ? "var(--color-success)" : "var(--color-danger)",
            }}
          >
            {changePositive ? "↑" : "↓"} {change} vs last period
          </p>
        )}
      </div>

      <div
        className="w-10 h-10 rounded-lg flex items-center justify-center shrink-0"
        style={{backgroundColor: `${iconColor}15`, color: iconColor}}
      >
        {icon}
      </div>
    </div>
  </BaseCard>
);
